<template>
  <div>
    <smart-conductor-pixel-tracker
      v-if="siteConfig"
      :careNetwork="siteConfig.careNetworkName"
    />
    <div
      v-if="!siteConfig"
      class="d-flex justify-center align-center"
      style="height: 100vh"
    >
      <base-loader loading />
    </div>
    <full-container v-else>
      <top-banner
        v-if="fields && fields.topBanner"
        :ctf_id="fields.topBanner.sys.id"
        :assets="assets"
      />
      <image-banner
        v-if="fields && fields.bannerImage"
        :fields="fields"
        :assets="assets"
      />
      <text-banner
        v-if="
          fields && (fields.heading || fields.subHeading) && !fields.bannerImage
        "
        :fields="fields"
      />
      <h1 class="sr-only" v-if="fields && !fields.heading">
        {{ fields.name }}
      </h1>
      <!-- all pages must have h1 for accessibility reasons -->
      <slices-block
        v-if="sortedEntries"
        :key="sortedEntries[0].sys.id"
        :entries="sortedEntries"
        :assets="assets"
      />
    </full-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { SITE_TYPES } from '@/store/modules/site'
import { LAYOUT_TYPES } from '@/store/modules/layout'
import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import FullContainer from '@/containers/full-container'
import SlicesBlock from '@/components/slices/slices-block'
import TopBanner from '@/components/slices/banners/top-banner'
import ImageBanner from '@/components/slices/banners/image-banner'
import TextBanner from '@/components/slices/banners/text-banner'
import SmartConductorPixelTracker from '@/components/base/smart-conductor-pixel-tracker'
import { forceCacheDump } from '../plugins/cache-service'

export default {
  name: 'Page',
  metaInfo () {
    if (this.fields) {
      return {
        title: this.fields.title,
        meta: [
          {
            name: 'description',
            content: this.fields.pageDescription
          }
        ]
      }
    } else {
      return {}
    }
  },
  components: {
    TopBanner,
    TextBanner,
    FullContainer,
    SlicesBlock,
    ImageBanner,
    SmartConductorPixelTracker
  },
  data () {
    return {
      fields: null,
      sortedEntries: null,
      assets: null
    }
  },
  computed: {
    ...mapGetters({ defaultPage: SITE_TYPES.getters.defaultPage }),
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    route () {
      forceCacheDump()
      return this.$route.fullPath
    }
  },
  watch: {
    route: {
      handler: 'fetchPage'
    },
    siteConfig: {
      handler: 'fetchPage',
      immediate: true
    }
  },
  methods: {
    ...mapMutations({
      setHasSlantedBackground:
        LAYOUT_TYPES.mutations.SET_PAGE_HAS_SLANTED_BACKGROUND
    }),
    async fetchPage () {
      if (!this.siteConfig) {
        return
      }
      const sitePage = this.siteConfig.pages.find(p => p.route === this.$route.path)

      this.$store.dispatch(LAYOUT_TYPES.actions.resetPageLastUpdateTime, new Date(sitePage.updatedAt))

      const { items, includes } = await queryCTF(
        `&content_type=page&select=fields&sys.id=${
          sitePage ? sitePage.id : null
        }`
      )
      if (items && includes) {
        this.setHasSlantedBackground(false)
        this.fields = items[0].fields
        if (includes.Entry) {
          this.sortedEntries = sortCTFEntries(
            this.fields.slices,
            includes.Entry
          )
        }
        if (includes.Asset) {
          this.assets = includes.Asset
        }
      }
    }
  }
}
</script>
